var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.params.title,
            visible: _vm.isShowDialog,
            "close-on-click-modal": false,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowDialog = $event
            },
            closed: _vm.onDialogClosed,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "max-height": "500px",
                overflow: "auto",
              },
            },
            _vm._l(_vm.params.content, function (item, index) {
              return _c("p", { key: index, staticStyle: { margin: "7px 0" } }, [
                _vm._v("\n        " + _vm._s(item.message) + "\n      "),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  ref: "confirmBtn",
                  attrs: { type: "primary", size: "small", autofocus: true },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v(_vm._s(_vm.params.confirmText))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }